import { onDocumentReady } from '../../../scripts/util/events';
import $ from 'jquery';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';

onDocumentReady(() => {
  let $videoBlocks = $('.js-video-block-poster');

  if ($videoBlocks.length) {
    $videoBlocks.fancybox({
      zoom: false,
      maxHeight: 1240,
      minHeight: 1115,
      fitToView: true,
      autoSize: false,
    });
  }
});
